<template>
  <div>
    <div class="container mx-auto flex flex-col laptop:flex-row pt-12 lg:pt-32">
      <div class="laptop:w-6/12 p-5 md:p-0 laptop:pl-0 laptop:mx-24 md:mx-8 md:w-5/6">
        <MARSTitle h1><div v-html="$t('pricing.pricing-title')" /></MARSTitle>
      </div>
      <div class="laptop:w-5/12 p-5 md:p-0 laptop:pl-0 laptop:mr-24 md:mx-8 md:w-5/6 mt-8 laptop:mt-4 laptop:mb-0">
        <p class="text-standard laptop:text-slg md:text-base leading-7" v-html="$t('pricing.pricing-text-1')" />
        <p class="text-standard laptop:text-slg md:text-base leading-7 py-8" v-html="$t('pricing.pricing-text-2')" />
      </div>
    </div>

    <PricingBlock />

  </div>
</template>

<script lang="ts">
import MARSTitle from '@/components/MARSTitle.vue'
import PricingBlock, {pricingData} from '@/components/PricingBlock.vue'

export default defineNuxtComponent({
  components: { MARSTitle, PricingBlock },
  data() {
    return {
      paymentFrequency: 'monthly',
      maxDiscountPercentage: '11%',
      selectedPlan: 'starter',
      pricing: pricingData,
    }
  },
  computed: {
    filteredPlans() {
      return this.pricing.filter(plan => plan.key === this.selectedPlan)
    },
    monthlyPayment() {
      return this.paymentFrequency === 'monthly'
    }
  }
})
</script>

<style scoped>
input[type=radio] {
  width: 1.625rem;
  min-width: 1.625rem;
  height: 1.625rem;
  border-radius: 100%;
  border: 1px solid white;
  appearance: none;
}

input[type=radio]:checked {
  background: radial-gradient(var(--color-highlight) 45%, rgba(255, 0, 0, 0) 51%);
}

</style>
